import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ManagedLoginService } from './shell/services/managed-login.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,CommonModule],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'Modernize Angular Admin Tempplate';

  isTokenReady=false;

  constructor(private managedLoginService: ManagedLoginService) {  }

  async ngOnInit() {
    const idToken = localStorage.getItem('id_token');
    const refreshToken = localStorage.getItem('refresh_token');
  
    if (idToken && refreshToken) {
      if (this.managedLoginService.isTokenExpired()) {
        await this.managedLoginService.refreshToken()
      } else {
        this.managedLoginService.scheduleTokenRefresh();
      }
    }
    
    this.isTokenReady = true;
  }


}
